import { Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

// Placeholder gris con ícono (simple, sin garabato)
const collateralPlaceholder =
  "data:image/svg+xml;utf8," +
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'>" +
  "<rect width='100%25' height='100%25' fill='%23e6e6e6'/>" +
  "<g transform='translate(400 250)'>" +
  "<rect x='-45' y='-35' width='90' height='70' rx='6' ry='6' fill='none' stroke='%239e9e9e' stroke-width='6'/>" +
  "<circle cx='-20' cy='-10' r='6' fill='%239e9e9e'/>" +
  "<polyline points='-35,25 -10,0 20,25' fill='none' stroke='%239e9e9e' stroke-width='6'/>" +
  "</g></svg>"

export const HeaderCollateralImages = ({ useFetchInit }) => {

  const {
    globalStates,
    Actions,
    Forms
  } = useFetchInit

  const { handleNextCollateralImage, handlePreviousCollateralImage } = Actions
  const { FormCollateral: { formState } } = Forms

  const { imagesCurrentIndex, showSection } = globalStates

  const images = formState.images || []

  const currentImage =
    images && images.length > 0
      ? images[imagesCurrentIndex]?.document_path
      : collateralPlaceholder;

  return (
    <Grid
      container
      spacing={2}
      style={{ marginTop: '1rem' }}
      alignItems="center"
      justifyContent="center"
    >
      {/* IMAGEN / PLACEHOLDER */}
      <Grid
        item
        xs={12}
        sm={8}
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <img
          src={currentImage}
          alt="Garantía"
          style={{
            width: '60vw',
            height: '50vh',
            objectFit: 'contain',
            borderRadius: '8px',
            maxWidth: '100%',
            maxHeight: '100%',
          }}
        />
      </Grid>

      {/* CONTROLES */}
      <Grid
        item
        xs={12}
        sm={4}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            maxWidth: '26rem',
          }}
        >
          <Button
            startIcon={<ArrowLeftCircle size={40} />}
            variant="contained"
            type="button"
            className="btn-round"
            color="inherit"
            sx={{ height: '5rem', width: '13rem' }}
            onClick={handlePreviousCollateralImage}
            disabled={images.length <= 1}
          />

          <Button
            startIcon={<ArrowRightCircle size={40} />}
            variant="contained"
            type="button"
            className="btn-round"
            color="inherit"
            sx={{ height: '5rem', width: '13rem' }}
            onClick={handleNextCollateralImage}
            disabled={images.length <= 1}
          />
        </div>

        {(showSection !== 'IMAGE') && (
          <Typography variant="h6" sx={{ textAlign: 'center', mt: 2 }}>
            {formState.idcollateral > 0 ? `Garantía: ${formState.title || ''}` : ''}
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}
